import styled, { css } from 'styled-components';
import { upTo } from 'js/services/MediaQuery';

const colStyle = css`
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  grid-column-gap: 1rem;
  grid-row-gap: 1rem;

  ${({ breakpoint }) => upTo(breakpoint || 'md')`
    grid-template-columns: 100%;
  `}
`;

export default styled.div`
  padding: 0 1rem;
  ${({ cols }) => (cols ? colStyle : null)}

  & + & {
    margin-top: 1rem;
  }
`;
